import { MortgageState } from "./types";

export const defaultState = (): MortgageState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    mortgages: [],
    links: {}
  };
};

export const state = defaultState();
